import Category from "../../Inputs/Category";
import Rpps from "../../Inputs/Rpps";
import Siret from "../../Inputs/Siret";
import Status from "../../Inputs/Status";
import { useState } from "react";
import status from "../../../config/status.json"
import { txt } from "../../../services/translation";
import frenchCountries from "../../../config/frenchCountries";
import Drop from "../../Inputs/Drop";

export default function Pro({user, onChange, show, errors, studentFile, onStudentFileChange}){

    const [visibleFields, setVisibleFields] = useState([])

    const display = field => visibleFields.includes(field)

    useState(() => {

        let defaultFields = ['category','status'];

        const userStatus = status.find(s => s.category === user?.category?.id && s.id === user?.status?.id);

        if(userStatus){
            defaultFields = defaultFields.concat(Array.isArray(userStatus.need) ? userStatus.need : []);
        }
        
        setVisibleFields(Array.isArray(show) ? show : defaultFields)

    }, [show, user])

    const handleChange = data => {

        if(!Array.isArray(show) && Array.isArray(data.status?.need)){
            setVisibleFields(['category','status'].concat(data.status.need))
        }

        return onChange(data)
    }

    const showStatus = display('status') && !!user?.category?.id && user?.category?.id !== 'nonsoignant';

    const handleCategoryChange = (category) => {
        if (category.id === 'nonsoignant') {
            const otherStatus = status.find(s => s.category === 'nonsoignant' && s.id === 'autre');
            return handleChange({...user, category, status: otherStatus });
        }
        return handleChange({...user, category});
    }

    return show && <>

        {display('category') &&
            <Category 
                value={user.category}
                onChange={handleCategoryChange}
                required
            />
        }

        {frenchCountries.includes(user.country) && <>

            {showStatus && 

                <Status
                    label="Statut d'exercice de votre profession"
                    category={user.category?.id}
                    value={user.status}
                    onChange={status => handleChange({...user, status})}
                    required
                />
            }

            {display('rpps') && 
            
                <Rpps 
                    label="Numéro RPPS (facultatif à cette étape)"
                    value={user.rpps}
                    onChange={rpps => handleChange({...user, rpps})}
                />
            }

            {display('siret') && 
            
                <Siret 
                    value={user.siret}
                    onChange={siret => handleChange({...user, siret})}
                />
            }

            {display('studentProof') && 
                
                <Drop
                    id='student-proof'
                    label={txt('importStudentProof')}
                    value={studentFile}
                    onChange={onStudentFileChange}
                    accept={['image/jpeg','image/jpg','image/png','application/pdf']}
                    maxSize={1000000}
                    error={errors?.studentFile}
                />

            }

        </>}
    
    </>
}